module.exports = __webpack_public_path__ + "static/scale-model-of-battlefield-colorado-in-colorado-springs-colorado-4712af271ecf11a00ee7fbefcc2d9246.png";